import type { ContextMenu } from 'components/move-list/components/context-menu/config/types';
import type { Store, StoreActions } from 'components/move-list/store/types';
import { MoveList } from 'chessboard/model/move-list/types';
import { CONTEXT_MENU_ACTION_NAMES } from '../config/context-menu-action-names';

/**
 * Create HideAllAnnotations action
 */
export function createHideAllAnnotations(
  store: Store,
  storeActions: StoreActions,
): ContextMenu.Action {
  return {
    getDisplayName: () => MoveList.Translation.Actions.HideAllAnnotations,
    action: CONTEXT_MENU_ACTION_NAMES.HideAllAnnotations,
    isVisible,
    handler,
  };

  /**
   * Visible if annotations are not hidden
   */
  function isVisible() {
    return !store.annotationsHidden.get();
  }

  /**
   * handler to hide annotations
   */
  function handler(): void {
    storeActions.setAnnotationsHidden(true);
  }
}
